import { FC } from 'react';
import { Input } from '@/components/ui';

interface BasicInfoSectionProps {
  title: string;
  subtitle: string;
  mainText: string;
  onTitleChange: (value: string) => void;
  onSubtitleChange: (value: string) => void;
  onMainTextChange: (value: string) => void;
  disabled?: boolean;
}

export const BasicInfoSection: FC<BasicInfoSectionProps> = ({
  title,
  subtitle,
  mainText,
  onTitleChange,
  onSubtitleChange,
  onMainTextChange,
  disabled = false,
}) => {
  return (
    <>
      <Input
        label="Title *"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        placeholder="Enter title (5-300 characters)"
        fullWidth
        disabled={disabled}
      />

      <Input
        label="Subtitle"
        value={subtitle}
        onChange={(e) => onSubtitleChange(e.target.value)}
        placeholder="Enter subtitle (10-500 characters)"
        fullWidth
        disabled={disabled}
      />

      <div className="space-y-2">
        <label className="block text-xs font-medium text-slate-600 mb-1.5">
          Main Text
        </label>
        <textarea
          value={mainText}
          onChange={(e) => onMainTextChange(e.target.value)}
          placeholder="Enter main text (max 1200 characters)"
          className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900/10 focus:border-slate-400 text-slate-900 resize-none disabled:bg-gray-100 disabled:cursor-not-allowed"
          rows={4}
          maxLength={1200}
          disabled={disabled}
        />
        <div className="text-xs text-gray-500 text-right">{mainText.length}/1200</div>
      </div>
    </>
  );
};

